<p-card header="Piece Rate Reset" >
  <div class="p-grid">
    <div class="p-col centered">
      <button pButton type="button"
        id="resetEntries"
        [disabled]="weekIsLocked || loadingIndicator || weekIsClosed"
        [icon]="loadingIndicator ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
        (click)="pieceRateReset();"
        label="Reset Entries"
        class="p-button-warning">
      </button>
    </div>
  </div>
</p-card>

<p-dialog header="Piece Rate Reset" [(visible)]="modalVisible" [modal]="true" appendTo="body">
  <p>Are you sure? This will erase all {{activity.description}} entries currently entered.</p>
  <p-footer>
    <button pButton type="button" class="p-button-info" label="Cancel" id="cancelResetEntries" (click)="cancelPieceRateResetDialog()" [disabled]="loadingIndicator"></button>
    <button class="p-button-warning" pButton type="button" label="Reset" id="confirmResetEntries" (click)="doPieceRateReset()" [disabled]="loadingIndicator"
    [icon]="loadingIndicator ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></button>
  </p-footer>
</p-dialog>
